import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Row, Col, Table } from 'antd';

import { uniqueId } from '../../../../../../../data/config/utils';
import EditablePageHeader from '../../../../../../pagecontainer/components/editablepageheader';
import ModalFooter from '../../../../../../../components/modalfooter';


class SimpleEntity extends Component {
    constructor() {
        super();
        this.utteranceTableColumns = [
            {
                title: "Labeled Utterances",
                key: "text",
                dataIndex: "text",
                render: (text) => {
                    return (
                        <div className="ori-flex-row ">
                            <div className="ori-bg-default ori-lr-pad-10 ori-tb-pad-3 ori-border-radius-4">{text}</div>
                        </div>
                    )
                }
            }
        ];
    }

    render() {
        const { page_details, entity_details, actions, updateEntity, goToEntitiesPage } = this.props;
        const mobile = page_details.device_data.screen_width < 768;

        return (
            <Row>
                <EditablePageHeader editable title={entity_details.active_entity_data.entity.name}  onChangeTitle={(e) => actions.updateEntityState(e.target.value, 'active_entity_data.entity.name')} />
                <Col xs={24} sm={{ span: 18, offset: 3 }} md={{ span: 16, offset: 4 }}>
                    <Table className="ori-card-row-table" rowClassName="ori-bg-white ori-border-radius-4 ori-box-shadow-light" scroll={{ x: 600 }} size={mobile ? "small" : "middle"} rowKey={uniqueId} columns={this.utteranceTableColumns} dataSource={entity_details.active_entity_data.utterances} />
                </Col>
                <Col xs={24} className="ori-pad-10">
                    <ModalFooter button_ok_text={entity_details.loaders.entity_updating ? 'Saving' : 'Save'} loading={entity_details.loaders.entity_updating} handleOkClick={updateEntity} handleCancelClick={goToEntitiesPage} capsule_button />
                </Col>
            </Row>
        );

    }
}

SimpleEntity.propTypes = {
    entity_details: PropTypes.object,
    actions: PropTypes.object,
    page_details: PropTypes.object,
    match: PropTypes.object,
    updateEntity: PropTypes.func,
    goToEntitiesPage: PropTypes.func,
};

export default SimpleEntity;



// WEBPACK FOOTER //
// ./src/app/pagecontainer/modules/botbuilder/entities/editentity/simpleentity/index.js